import { takeLatest, call, put } from 'redux-saga/effects'
import * as constants from 'store/constants'
import api from './api'

function* getVariableRemuneration({ payload }) {
    try {
        yield put({ type: constants.VARIABLE_REMUNERATION_LOADING, payload: true })
        const res = yield call(api.getVariableRemuneration, payload)

        yield put({
            type: constants.VARIABLE_REMUNERATION_DATA,
            payload: res,
        })

        yield put({ type: constants.VARIABLE_REMUNERATION_LOADING, payload: false })
    } catch (e) {
        console.error(`${e.message}`)

        yield put({ type: constants.VARIABLE_REMUNERATION_ERROR, payload: e.message })
        yield put({ type: constants.VARIABLE_REMUNERATION_LOADING, payload: false })
    }
}

export default function* saga() {
    yield takeLatest(constants.GET_VARIABLE_REMUNERATION, getVariableRemuneration)
}